module.exports = __webpack_public_path__ + "static/media/template (4).041a7327.png";